import React from 'react';

import linkPagosLogo from '@/assets/linkdepagos.png';
import { Button, Divider, Loader } from '@/components';
import usePinsAccount from '@/hooks/usePinsAccount';
import { useGetInitMyaccount } from '@/modules/my-account/hooks/useMyAccount';

interface Props {
  isHowTo: boolean;
}

const GetPins = () => {
  const { pinsData } = usePinsAccount();
  const { data } = useGetInitMyaccount();
  if (!data) return <Loader isVisible={true} />;
  if (!('usuario' in data)) return null;
  const formatedDoc = String(data?.usuario?.nroDoc).padStart(8, '0');
  const docType = data?.usuario?.idTipoDoc;
  const productId = String(pinsData?.selectedProduct?.id ?? '02').padStart(
    2,
    '0'
  );
  const PMC = `${productId}${docType}${formatedDoc}`;
  return (
    <>
      <li>
        Ingresa a <strong>www.redlink.com.ar</strong> y seleccioná tu banco.
      </li>
      <li>
        Logueate con tu usuario (es el mismo que usás en el home banking de tu
        banco)
      </li>
      <li>
        En &quot;Pago de impuestos y servicios&quot; selecciona el rubro
        &quot;Cobranzas&quot;.
      </li>
      <li>
        Ingresa tu código de Link Pagos:{' '}
        <strong className="text-gdt-blue">{PMC}</strong>
      </li>
      <li>
        Elegí &quot;Gran DT&quot; e ingresá tu N° de referencia:{' '}
        <strong className="text-gdt-blue">{data?.usuario?.nroDoc}</strong>
      </li>
      <li>
        Finalmente ingresá, como monto a cargar, el precio exacto del pack que
        deseás comprar.
      </li>
      <li>
        En el transcurso de las próximas 72 hs hábiles tendrás acreditado tus
        pines en tu cuenta de Gran DT.
      </li>
    </>
  );
};

const HowTo = () => {
  const { data } = useGetInitMyaccount();
  if (!data) return null;
  if (!('usuario' in data)) return null;
  const formatedDoc = String(data?.usuario?.nroDoc).padStart(8, '0');
  const docType = data?.usuario?.idTipoDoc;
  const productId = '09';
  const PMC = `${productId}${docType}${formatedDoc}`;
  return (
    <>
      <li>
        Ingresa a <strong>www.redlink.com.ar</strong> y seleccioná tu banco.
      </li>
      <li>
        Logueate con tu usuario (es el mismo que usás en el home banking de tu
        banco)
      </li>
      <li>
        En &quot;Pago de impuestos y servicios&quot; selecciona el rubro
        &quot;Cobranzas&quot;.
      </li>
      <li>
        Ingresá el siguiente código de pago:{' '}
        <strong className="text-gdt-blue">{PMC}</strong>
      </li>
      <li>
        Elegí &quot;Gran DT&quot; e ingresá tu N° de referencia:{' '}
        <strong className="text-gdt-blue">{data?.usuario?.nroDoc}</strong>
      </li>
      <li>
        Finalmente completá el monto que deseás cargar. Éste se te acreditará en
        el transcurso de las próximas 72 hs hábiles.
      </li>
    </>
  );
};

export const PayWithLinkPagos: React.FC<Props> = React.memo(({ isHowTo }) => {
  return (
    <div className="flex flex-col mb-10">
      <h3 className="text-gdt-gray text-base font-bold mx-auto">
        {isHowTo ? '¿Cómo cargar saldo?' : 'Obtené tus pines con'}
      </h3>
      <img
        alt="pago mis cuentas"
        className="w-14 mx-auto mt-3"
        src={linkPagosLogo}
      />
      <Divider className="my-5 border-2" type="horizontal" />
      {isHowTo && <h4 className="font-bold mx-auto">¿Cómo cargar saldo?</h4>}
      <ol className="list-decimal font-normal px-6 mb-6">
        {isHowTo ? <HowTo /> : <GetPins />}
      </ol>
      <Button
        className="w-full mt-4"
        type="button"
        variant="primary"
        onClick={() => window.open('https://redlink.com.ar/', '_blank')}
      >
        Ir a Link Pagos
      </Button>
    </div>
  );
});

PayWithLinkPagos.displayName = 'PayWithLinkPagos';
